/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createEmployment} from '../api'

export const useMutationCreateEmployment = createReactQueryMutationHook('createEmployment', createEmployment)
